module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/120.1cd39520.svg";